<template>
    <el-drawer :visible.sync="visible" :size="885" :withHeader="false" custom-class="module_editor__wrap">
        <div class="module_editor__inner" v-loading="loading" v-if="moduleData">
            <div class="module_editor__preivew">
                <div class="module_editor__header">
                    <h3 class="module_editor__title">预览效果</h3>
                    <p class="module_editor__tips">点击蓝色区域内容可以自由编辑</p>
                </div>
                <div class="module_editor__preivew__inner scrollbar-default">
                    <preview :parent-shop-id="tenantId" @select="onChangeDOM" :defaultActiveIndex="domIndex" :module-data="moduleData" :multiple="multiple"></preview>
                    <preview :parent-shop-id="tenantId" class="module_editor__preivew__canvas" ref="preview" :module-data="moduleData" :multiple="multiple"></preview>
                </div>
            </div>
            <div class="module_editor__dom" v-if="currentDom">
                <div class="module_editor__header">
                    <h3 class="module_editor__title">内容编辑</h3>
                    <div class="module_editor__restore" v-if="oldJsonStr" @click="onRestoreDate">
                        恢复默认效果
                    </div>
                    <div class="module_editor__download" @click="onDownloadFiles">
                        <as-icon class="module_editor__download_icon" name="xiazai1"></as-icon>
                        下载素材
                    </div>
                </div>
                <el-form ref="editorFormRef" :model="editorForm" :rules="editorFormRules" class="module_editor__form scrollbar-default" label-position="top" >
                    <template v-if="currentDom.type == 1">
                        <el-form-item label="文字内容：">
                            <el-input class="module_editor__text_input" v-model="currentDom.text" v-if="currentDom.textType === 'text'">
                                <div class="module_editor__color" slot="append">
                                    <el-color-picker v-model="currentDom.style.color"></el-color-picker>
                                </div>
                            </el-input>
                            <div class="module_editor__textarea" v-else>
                                <el-input class="module_editor__textarea_input" v-model="currentDom.text" type="textarea" rows="5"></el-input>
                                <div class="module_editor__color">
                                    <span>文字颜色</span>
                                    <el-color-picker v-model="currentDom.style.color"></el-color-picker>
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item label="大小：">
                            <el-input type="number" v-model="currentDom.style.width">
                                <template slot="prepend">宽</template>
                            </el-input>
                            <el-input type="number" v-model="currentDom.style.height">
                                <template slot="prepend">高</template>
                            </el-input>
                        </el-form-item>
                    </template>
                    <template v-if="currentDom.type == 2 && !(orderStyle == 2 && [11,12].includes(domIndex))">
                        <el-form-item label="图片内容：">
                            <img class="module_editor__img" style="margin: 0" :src="currentDom.content | urlCDN(currentDom.isTempImg, tenantId)" />
                            <p class="module_editor__tips">图片尺寸{{ currentDom.style.width }}px * {{ currentDom.style.height }}px；图片格式为 png</p>
                            <el-button class="module_editor__select_img" icon="el-icon-edit" type="primary">
                                更换图片
                                <input @click.stop @change="onChangeImage" type="file" accept="image/*">
                            </el-button>
                        </el-form-item>
                    </template>
                    <template v-if="currentDom.type == 2 && orderStyle == 2 && [11,12].includes(domIndex)">
                        <p class="domTips">这是一个数据集内容，可用来展示用户的资产数据</p>
                        <el-form-item label="模块类型">
                            <div class="moudleType">
                                <div v-for="item in moudleTypeList" :key="item" :class="{'selected':currentDom.content==item.src}" @click="changeMoudleType(item)">
                                    <div class="moudel">
                                        <p class="title" :style="{'color':item.color}">{{ item.title }}</p>
                                        <img :src="item.src | urlCDN(currentDom.isTempImg, tenantId)" alt="">
                                    </div>
                                    <p class="text">{{ item.text }}</p>
                                </div>
                            </div>
                        </el-form-item>
                    </template>
                    <el-form-item label="项目选择" v-if="orderStyle==1&&domIndex==4">
                        <AsServiceitemAdvancedSelector
                            ref="asServiceitemAdvancedSelector" 
                            :showTimes="false" 
                            v-model="serviceItemDialogVisible"
                            :load-data="loadServiceItemData" 
                            :default-checked-keys="savedItemList.map(item => item.itemid)"
                            :default-select-view-data="savedItemList"
                            @on-confirm="itemSelectedData"
                            :multiple="true">
                        </AsServiceitemAdvancedSelector>
                    </el-form-item>
                    <el-form-item label="跳转行为" v-if="!hiddenAction&&!(orderStyle==1&&domIndex==4)">
                        <div class="action_type">
                            <!-- <el-select class="action_type_select" v-model="actionSelect" @change="changeActionSelect">
                                <el-option v-for="typeItem in typeList" :key="typeItem.id" :label="typeItem.label" :value="typeItem.id"></el-option>
                            </el-select> -->
                            <el-cascader ref="cascader" v-model="actionArray" :options="typeList" :props="{ label: 'name', expandTrigger: 'hover' }" @change="changeActionSelect" size="small" :show-all-levels="false"></el-cascader>
                            <el-popover
                                v-show="showTipImage.includes(actionSelect)"
                                placement="top"
                                title=""
                                width="200"
                                trigger="hover">
                                <div class="action_type_image" :class="actionSelectImageClass"></div>
                                <as-icon slot="reference" class="action_type_icon" name="tishi1"></as-icon>
                            </el-popover>
                        </div>
                    </el-form-item>
                    <el-form-item label="商品选择" v-if="actionSelect === 1">
                        <as-mallitem-advanced-selector
                         ref='mallitemSelector' 
                         :default-checked-keys='defaultCheckedMallItemId' 
                         :load-data="loadMallItemData" 
                         @change="onSelectServiceChange">
                         <template #custorm>
                            <mock-el-select
                                size="small"
                                :multiple="true"
                                :tag-list="currentDom.actionCur"
                                placeholder="请选择商品"
                                :collapseTags="true"
                                :props="{label: 'name', id: 'id'}"
                                @close="handleTagClose"
                                @click.native="onShowMallItemSelector"
                                :wordNumber="10">
                            </mock-el-select>
                         </template>
                        </as-mallitem-advanced-selector>
                    </el-form-item>
                    <el-form-item label="预约列表" v-if="actionSelect === 2" v-loading="loadingFormItem">
                        <el-select size="small" filterable v-model="slectStoreId" @change="onSelectStoreChange">
                            <el-option v-for="(item, index) in storeList" :key="index" :label="item.name" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="红包裂变活动" v-if="actionSelect === 30" v-loading="loadingFormItem">
                        <el-select size="small" filterable v-model="fissionSelectValue" @change="onSelectStoreChange">
                            <el-option v-for="(item, index) in fissionList" :key="index" :label="item.title" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="手艺人选择" v-if="actionSelect === 3">
                        <as-emp-advanced-selector
                            ref="userSelector" 
                            class="user-selector"
                            clearable
                            :new-select="true"
                            placeholder="请选择手艺人"
                            :show-mock-el-select-visible="true"
                            :load-data="loadEmployeeData" 
                            :select-id="defaultUsersKey[0]"
                            :default-checked-keys="defaultUsersKey"
                            :multiple="false"
                            @change="onSelectUserChange">
                        </as-emp-advanced-selector>
                    </el-form-item>
                    <el-form-item label="上传视频" v-if="actionSelect === 10">
                        <el-button class="module_editor__select_video" icon="el-icon-edit" type="primary">
                            {{ videoInfoUrl ? '更换' : '上传' }}视频
                            <input @change="onChangeVideoFile" type="file" accept=".mp4">
                        </el-button>
                        <video v-show="videoInfoUrl" class="module_editor__video_view" controls :src="videoInfoUrl"></video>
                    </el-form-item>
                    <el-form-item label="直播间" v-if="actionSelect === 15" v-loading="loadingFormItem">
                        <el-select size="small" filterable v-model="liveRoomId" @change="changeLiveRoom">
                            <el-option v-for="(item, index) in liveRoomList" :key="index" :label="item.name" :value="item.roomid"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="链接标题" v-if="actionSelect === 19">
                        <el-input v-model="editorForm.title" placeholder="请输入链接标题"></el-input>
                    </el-form-item>
                    <el-form-item label="链接地址" prop="url" v-if="actionSelect === 19">
                        <el-input v-model="editorForm.url"  placeholder="请输入链接地址"></el-input>
                    </el-form-item>
                </el-form>
                <el-button class="module_editor__save" type="primary" @click="onSave">保存</el-button>
            </div>
        </div>
    </el-drawer>
</template>
<script>
import Preview from './preview.vue'
import html2canvas from 'html2canvas'
import UploadImage from '@/components/upload-image'
import AsIcon from '@/components/icon'
import AsEmpAdvancedSelector from '@/components/emp-advanced-selector/emp-advanced-selector.vue'
import AsMallitemAdvancedSelector from '@/components/mallitem-advanced-selector/mallitem-advanced-selector.vue'
import MockElSelect from '@/components/mock-el-select';
import Utils from '@/js/utils'
import ImageMixins from './mixins/imageUtils'
import AsServiceitemAdvancedSelector from '@/components/serviceitem-advanced-selector/serviceitem-advanced-selector.vue'

const showTipImage = [5, 6, 8, 9, 10, 11, 12, 13, 14, 20, 21, 22, 23, 24, 30];
export default {
    name: 'moduleEditor',
    components: {
        Preview,
        AsIcon,
        AsEmpAdvancedSelector,
        AsMallitemAdvancedSelector,
        MockElSelect,
        AsServiceitemAdvancedSelector
    },
    mixins: [ ImageMixins ],
    data() {
        return {
            savedItemList: [],
            serviceItemDialogVisible: false,
            fontFamilyCacheMap: {},
            loading: false,
            loadingFormItem: false,
            domIndex: null,
            visible: false,
            moduleData: null,
            currentDom: null,
            actionSelect: 7,
            actionArray: [104, 7],
            showTipImage,
            defaultUsersKey: [],
            defaultCheckedMallItemId: [],
            storeList: [],
            liveRoomList: [],
            fissionList: [],
            reservationShop: '',
            liveRoomId: '',
            videoInfoUrl: '',
            slectStoreId: '',
            fissionSelectValue: '',
            editorForm: {
                title: '',
                url: ''
            },
            editorFormRules: {
                url: [{ required: true, message: '请输入链接地址', trigger: 'blur' }]
            },
            typeList: [
                {
                id: 101,
                value: 101,
                name: '基础页面',
                children: [
                    {   
                    value: 25,
                    name: '首页',
                    id: 25,
                    },  
                    {   
                    value: 26,
                    name: '门店',
                    id: 26,
                    },
                    {   
                    value: 27,
                    name: '作品',
                    id: 27,
                    },
                    {   
                    value: 28,
                    name: '商城',
                    id: 28,
                    },
                    {   
                    value: 29,
                    name: '我的',
                    id: 29,
                    },
                    {
                    id: 1,
                    value: 1,
                    name: '到商品列表'
                    },
                    {
                    id: 2,
                    value: 2,
                    name: '到预约列表'
                    },
                    {
                    id: 3,
                    value: 3,
                    name: '到手艺人'
                    },
                    {
                    id: 9,
                    value: 9,
                    name: '到会员特惠'
                    },
                    {
                    id: 8,
                    value: 8,
                    name: '到价目表'
                    },
                    {
                    id: 23,
                    value: 23,
                    name: '到品牌介绍'
                    },
                ]
                },
                {
                id: 102,
                value: 102,
                name: '营销工具',
                children: [
                    {
                    id: 5,
                    value: 5,
                    name: '到领红包'
                    },
                    {
                    id: 6,
                    value: 6,
                    name: '到无门槛抽奖'
                    },
                    {
                    id: 11,
                    value: 11,
                    name: '到特权卡'
                    },
                    {
                    id: 20,
                    value: 20,
                    name: '到积分商城'
                    },
                    {
                    id: 21,
                    value: 21,
                    name: '到积分抽奖'
                    },
                    {
                    id: 22,
                    value: 22,
                    name: '到投票活动'
                    },
                    {
                    id: 30,
                    value: 30,
                    name: '到红包裂变'
                    },
                ]
                },
                {
                id: 103,
                value: 103,
                name: '个人中心',
                children: [
                    {
                    id: 12,
                    value: 12,
                    name: '到会员卡'
                    },
                    {
                    id: 14,
                    value: 14,
                    name: '到自助充值'
                    },
                    {
                    id: 13,
                    value: 13,
                    name: '到套餐'
                    },
                    {
                    id: 24,
                    value: 24,
                    name: '到我的订单'
                    },
                ]
                },
                {
                id: 104,
                value: 104,
                name: '其他',
                children: [
                    // {
                    // id: 4,
                    // value: 4,
                    // name: '到内容页'
                    // },
                    
                    {
                    id: 10,
                    value: 10,
                    name: '到视频播放'
                    },
                    {
                    id: 15,
                    value: 15,
                    name: '到直播间'
                    },
                    {
                    id: 19,
                    value: 19,
                    name: '到链接'
                    },
                    {
                    id: 7,
                    value: 7,
                    name: '无行为'
                    },
                ]
                },
            ],
            options: null,
            hiddenAction: false,
            multiple: 2,
            canvasScale: 2.5,
            oldJsonStr: '',
            orderStyle: null,
            moudleTypeList: [
                {
                    title: '积分购',
                    src: 'assets_group/assets12/assets12_img09.png',
                    text: '用户积分数据',
                    color: "#333333",
                    actionType: 20
                },
                {
                    title: '领红包',
                    src: 'assets_group/assets12/assets12_img10.png',
                    text: '领红包活动',
                    color: "#FF0000",
                    actionType: 5
                },
                {
                    title: '特权Go',
                    src: 'assets_group/assets12/assets12_img11.png',
                    text: '特权中心',
                    color: "#A86814",
                    actionType: 11
                },
            ],
        }
    },
    watch: {
        'editorForm.title': {
            handler(val) {
                if (!this.currentDom.actionCur) {
                    this.currentDom.actionCur = {};
                }
                this.currentDom.actionCur.title = val;
            },
            deep: true
        },
        'editorForm.url': {
            handler(val) {
                if (!this.currentDom.actionCur) {
                    this.currentDom.actionCur = {};
                }
                this.currentDom.actionCur.url = val;
            },
            deep: true
        },
        actionSelect(val){
            if(!(this.actionArray && this.actionArray.length && this.actionArray[1] == val)){
                var pid = this.getParentId(val, this.typeList)
                    this.$nextTick(function(){
                        this.actionArray = [pid, val]
                    })
            }
        },
    },
    computed: {
        actionSelectImageClass() {
            return `actionSelect_${this.actionSelect}`;
        }
    },
    methods: {
        getParentId(id, list){
            var pid = null
            for (var index = 0; index < list.length; index++) {
            for (let i = 0; i < list[index].children.length; i++) {
                var item = list[index].children[i];
                if(item.id == id){
                pid = list[index].id
                break
                }
            }
            if(pid){
                break
            }
            }
            return pid
        },
        changeMoudleType(item){
            this.$set(this.moduleData.domList[this.domIndex],"content",item.src)
            this.$set(this.moduleData.domList[this.domIndex],"actionType",item.actionType)
            if(this.domIndex == 11){
                this.$set(this.moduleData.domList[5],"text",item.title)
            }else{
                this.$set(this.moduleData.domList[6],"text",item.title)
            }
        },
        async onChangeImage(e) {
            const file = e.target.files[0];
            const imageSrc = await Utils.renderFileAsDataURL(file);
            const { width, height } = this.currentDom.style;
            UploadImage.open({
                imageSrc,
                tenantId: this.tenantId,
                aspectRatio: width/height,
                uploadImageFunction: this.options.uploadImageFunction,
                onSuccess: data => {
                    this.currentDom.content = data.content;
                    this.currentDom.isTempImg = false;
                    this.moduleData.domList.splice(this.domIndex, 1, this.currentDom);
                }
            })
        },
        onDownloadFiles() {
            const { domList } =  this.moduleData || { domList: [] };
            const imageDomList = domList.filter((item) => item.type === 2 && !item.disabled).map((item) => {
                item.url = this.imageUrlCDN(item.content, item.isTempImg, this.tenantId);
                return item;
            });
            if (imageDomList.length && this.options && this.options.downloadFiles) {
                this.loading = true;
                this.options.downloadFiles({
                    files: imageDomList,
                    onSuccess: (data) => {
                        this.loading = false;
                    },
                    onError: (error) => {
                        this.loading = false;
                    }
                })
            }
        },
        onRestoreDate() {
            this.$message({
                showClose: true,
                message: '已恢复默认效果',
                type: 'success'
            });
            var oldjson = JSON.parse(this.oldJsonStr)
            this.moduleData = oldjson
            this.domIndex = null
            this.currentDom = null
            this.$nextTick(() => {
                const { domList } = this.moduleData;
                this.domIndex = domList.findIndex(item => !item.disabled);
                this.currentDom = domList[this.domIndex];
                this.onChangeDOM({ domData: domList[this.domIndex], domIndex: this.domIndex })
            })
        },
        onChangeVideoFile(e) {
            const file = e.target.files[0];
            const uploadVideoOption = this.options && this.options.uploadVideoOption ? this.options.uploadVideoOption : {};
            const { size } = uploadVideoOption;
            let warningMessage;

            if (!(file.type.indexOf("mp4") != -1 || file.type.indexOf("3gp") != -1 || file.type.indexOf("m3u8") != -1)) {
                warningMessage = "请上传正确MP4/3gp/m3u8格式的视频文件！";
            }
            if (file.size > (size || 20) * 1024 * 1024) {
                warningMessage = `只能上传小于${size || 20}M的视频`;
            }

            if (warningMessage) {
                this.$message({
                    showClose: true,
                    message: warningMessage,
                    type: 'warning'
                });
                return;
            }

            if (this.options && this.options.uploadVideoFunction) {
                this.loading = true;
                this.options.uploadVideoFunction({
                    file,
                    onSuccess: (data) => {
                        this.loading = false;
                        this.videoInfoUrl = data.viewUrl;
                        this.currentDom.actionCur = {
                            videoSourceUrl: data.content,
                            viewUrl: data.viewUrl
                        }
                    },
                    onError: (data) => {
                        this.loading = false;
                    }
                })
            }
            e.target.value = ""; // 解决选择同一个文件第二次无法选中的问题
        },
        onHide() {
            this.visible = false;
            this.moduleData = null;
        },
        onSave() {
            this.$refs.editorFormRef.validate((valid) => {
                if (valid) {
                    this.loading = true;
                    setTimeout(() => {
                        const scale = this.canvasScale;
                        html2canvas(this.$refs.preview.$el, { allowTaint: true, useCORS: true, logging: true, scale }).then(canvas => {
                            const base64 = canvas.toDataURL("image/png", 1);
                            const { uploadImageFunction, onSave } = this.options;
                            uploadImageFunction({
                                base64,
                                onSuccess: (data) => {
                                    this.moduleData.imgUrl = data.content;
                                    this.moduleData.isTempImg = false;
                                    onSave && onSave(this.moduleData);
                                    this.loading = false;
                                    this.onHide();
                                },
                                onError: (data) => {
                                    this.loading = false;
                                    console.error('保存图片失败', data);
                                }
                            })
                        })
                    }, 200)
                }
            })
        },
        onChangeActionType(value, reset) {
            switch (value) {
                case 1:
                    if (reset) {
                        this.currentDom.actionCur = [];
                        this.defaultCheckedMallItemId = [];
                    }
                    break;
                case 2:
                    // 获取门店信息，用 select 允许搜索
                    if (reset) {
                        this.currentDom.actionCur = '';
                        this.slectStoreId = '';
                    }
                    this.loadStoreList();
                    break;
                case 15:
                    this.getLiveRoomData();
                    break;
                case 30:
                    this.getFissionList()
                    break
                default:
                    break;
            }
        },
        show(options) {
            this.moduleData = null;
            this.options = options;
            this.tenantId = options.tenantId;
            this.hiddenAction = options.hiddenAction || false
            this.multiple = options.multiple || 2
            this.canvasScale = options.canvasScale || 2.5
            this.loading = false;
            this.visible = true;
            this.oldJsonStr = options.oldJsonStr
            this.moduleData = JSON.parse(JSON.stringify(options.moduleData));
            this.orderStyle = this.moduleData.orderStyle || null
            const { domList } = this.moduleData;
            this.domIndex = domList.findIndex(item => !item.disabled);
            this.currentDom = domList[this.domIndex];
            this.onChangeDOM({ domData: domList[this.domIndex], domIndex: this.domIndex })
            this.loading = true;
            const fontFamilyDOMList = domList.filter(item => item.type == 1 && item.style.fontFamily && !this.fontFamilyCacheMap[item.style.fontFamily]);
            const fontPromiseList = fontFamilyDOMList.map(item => {
                const { fontFamily } = item.style;
                const font = new FontFace(fontFamily, `url(${this.cdnPath}${fontFamily}.ttf)`, {})
                return font.load();
            });
            if (!fontPromiseList.length) {
                this.loading = false;
                return;
            }
            Promise.all(fontPromiseList).then(resList => {
                resList.forEach((res, index) => {
                    document.fonts.add(res);
                    this.fontFamilyCacheMap[fontFamilyDOMList[index].style.fontFamily] = true;
                })
            }).catch(error => {
                console.error('字体加载失败', error);
            }).finally(() => {
                this.loading = false;
            })
        },
        onChangeDOM({ domData, domIndex }) {
            this.currentDom = domData;
            if(this.orderStyle == 1&&domIndex==4){
                this.currentDom.actionType = 99;
                this.savedItemList = this.currentDom.actionCur || []
            }
            if (!this.currentDom.actionType) {
                this.currentDom.actionType = 7;
                this.currentDom.actionCur = {};
            }
            this.domIndex = domIndex;
            if (parseInt(domData.type) === 1) {
                this.currentDom.textType = domData.text.length < 15 ? 'text' : 'textarea'; 
            }
            this.setCurrentDomParams(this.currentDom);
        },
        setCurrentDomParams (currentDom) {
            let actionType = currentDom.actionType || 7;
            this.actionSelect = actionType;
            this.defaultCheckedMallItemId = [];
            this.onChangeActionType(actionType);
            console.log(currentDom);
            if (currentDom.actionCur) {
                switch(actionType) {
                    case 1:
                        this.defaultCheckedMallItemId = currentDom.actionCur.map((item) => item.id);
                        break;
                    case 2:
                        this.slectStoreId = (typeof currentDom.actionCur === 'string') ? currentDom.actionCur : '';
                        break;
                    case 3:
                        this.defaultUsersKey = [currentDom.actionCur.craftsmanCur];
                        this.$nextTick(() => {
                            this.$refs.userSelector.selectListData = [{ name: currentDom.actionCur.craftsmanCurName }]
                        })
                        break;
                    case 10:
                        this.videoInfoUrl = currentDom.actionCur.viewUrl;
                        break;
                    case 19:
                        this.editorForm.title = currentDom.actionCur.title;
                        this.editorForm.url = currentDom.actionCur.url;
                        break;
                    case 30:
                        this.fissionSelectValue = (typeof currentDom.actionCur === 'number') ? currentDom.actionCur : '';
                        break
                }
            }
            if (currentDom.tvShowOpt && actionType === 15) {
                const tvShowOpt = JSON.parse(currentDom.tvShowOpt);
                this.liveRoomId = tvShowOpt.roomid;
            }
        },
        loadStoreList() {
            if (this.options && this.options.getShopList) {
                this.loadingFormItem = true;
                this.options.getShopList({
                    onError: () => {
                        this.loadingFormItem = false;
                        this.storeList = [];
                    },
                    onSuccess: (data) => {
                        this.loadingFormItem = false;
                        this.storeList = data;
                    }
                })
            }
        },
        getLiveRoomData() {
            if (this.options && this.options.getLiveRoom) {
                this.loadingFormItem = true;
                this.options.getLiveRoom({
                    onError: () => {
                        this.loadingFormItem = false;
                        this.liveRoomList = [];
                    },
                    onSuccess: (data) => {
                        this.loadingFormItem = false;
                        this.liveRoomList = data;
                    }
                })
            }
        },
        getFissionList() {
            if (this.options && this.options.getFissionList) {
                this.loadingFormItem = true;
                this.options.getFissionList({
                    onError: () => {
                        this.loadingFormItem = false;
                        this.fissionList = [];
                    },
                    onSuccess: (data) => {
                        this.loadingFormItem = false;
                        this.fissionList = data;
                    }
                })
            }
        },
        loadEmployeeData(done) {
            if (this.options && this.options.getEmployeeList) {
                this.options.getEmployeeList({
                    onError: () => {
                        done({});
                    },
                    onSuccess: (data) => {
                        done(data.listData, data.options)
                    }
                })
            }
        },
        loadMallItemData(done) {
            if (this.options && this.options.getMallItemData) {
                this.options.getMallItemData({
                    onError: () => {
                        done([]);
                    },
                    onSuccess: (data) => {
                        done(data)
                    }
                })
            }
        },
        loadServiceItemData(done){
            if (this.options && this.options.getServiceItemData) {
                this.options.getServiceItemData({
                    onError: () => {
                        done([]);
                    },
                    onSuccess: (data) => {
                        done(data)
                    }
                })
            }
        },
        changeActionSelect(value) {
            this.actionSelect = value[1]
            this.currentDom.actionType = value[1];

            this.onChangeActionType(value[1], true);
        },
        changeLiveRoom(value) {
            let data = this.liveRoomList;
            let selectRoomItem = data.find((item) => item.roomid === value);
            if (selectRoomItem) {
                this.currentDom.tvShowOpt = JSON.stringify({ roomid: selectRoomItem.roomid, customParams: selectRoomItem.customParams });
            } else {
                this.currentDom.tvShowOpt = undefined;
            }
        },
        onSelectUserChange(value) {
            let curentData = value && value.length ? value[0] : {};
            this.defaultUsersKey = [curentData.id];
            this.currentDom.actionCur = {
                craftsmanCurName: curentData.name,
                craftsmanCur: curentData.id,
                store: `${curentData.shopId}`
            }
        },
        onSelectServiceChange(value) {
            this.defaultCheckedMallItemId = value.map((item) => item.id);
            this.currentDom.actionCur = value.map((item) => {
                return {
                    allowGroupBuying: item.allowgroupbuying,
                    category: item.subCategoryName,
                    earnPoints: item.earnPoints,
                    endTime: item.endTime,
                    fornewreg: item.fornewreg,
                    groupBuyingDetail: item.groupbuyingdetail,
                    id: item.id,
                    images: item.images,
                    inituseamount: item.initUseAmount,
                    name: item.name,
                    originalprice: item.originalPrice,
                    price: item.price,
                    privilegePrice: '',
                    quickdescription: item.quickDescription,
                    saleprop: item.saleprop,
                    starttime: item.startTime,
                    status: item.status,
                    useamount: item.useAmount
                }
            })
        },
        itemSelectedData(value){
            console.log(value);
            this.savedItemList = value;
            this.currentDom.actionCur = value
        },
        onSelectStoreChange(value) {
            this.currentDom.actionCur = value;
        },
        onShowMallItemSelector() {
            this.$refs.mallitemSelector.onShowDialog();
        },
        handleTagClose(index) {
            this.currentDom.actionCur.splice(index, 1);
            this.currentDom.actionCur = this.currentDom.actionCur.map((item) => item);
            this.defaultCheckedMallItemId = this.currentDom.actionCur.map((item) => item.id);
        }
    }
}
</script>
<style lang="scss">
.module_editor__wrap {
    height: 100%;
    .module_editor__inner {
        display: flex;
        height: 100%;
        width: 885px;
    }
    .el-drawer__body {
        padding: 0;
        direction: ltr;
        height: 100%;
    }
    .el-form {
        margin-bottom: 25px;
        max-height: calc(100% - 120px);
        overflow-y: auto;
        margin-top: 25px;
    }
    .el-form-item {
        margin-top: 20px;
        margin-bottom: 5px;
        &:first-child {
            margin-top: 0;
        }
    }
    .el-form-item__label {
        padding: 0;
        font-size: 12px;
        line-height: 1.4;
        margin-bottom: 12px;
        color: #909090;
    }
    .el-button {
        width: 188px;
        border-radius: 2px;
    }
    .action_type {
        display: flex;
        align-items: center;
        position: relative;
        .action_type_select {
            flex-grow: 1;
        }
        .action_type_icon {
            margin-left: 5px;
            cursor: pointer;
            flex: none;
        }
    }
}
.module_editor__header {
    position: relative;
}
.module_editor__title {
    font-size: 14px;
    color: #333;
}
.module_editor__tips {
    margin-top: 15px;
    font-size: 12px;
    color: #909090;
}
.module_editor__download {
    position: absolute;
    top: 0;
    /*transform: translateY(-50%);*/
    right: 0;
    width: 87px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 1px 2px 3px 0 #CECECE;
    border-radius: 4px;
    font-size: 12px;
    cursor: pointer;
}
.module_editor__restore{
    position: absolute;
    top: 0;
    right: 95px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    cursor: pointer;
}
.module_editor__download_icon {
    font-size: 14px;
    margin-right: 3px;
}
.module_editor__preivew {
    height: 100%;
    flex: 0 0 425px;
    padding: 45px 24px 0;
    background-color: #f9f9f9;
}
.module_editor__preivew__inner {
    height: calc(100% - 53px);
    overflow-y: auto;
    position: relative;
    margin-top: 12px;
    border: 1px dashed #dedede;
    .module_editor__preivew__canvas {
        position: absolute;
        left: 0;
        top: 0;
        z-index: -1;
        .advanced_preview__dom {
            border: none;
        }
    }
}
.module_editor__preivew__inner .advanced_preview {
    border: none;
}
.module_editor__dom {
    flex: 0 0 420px;
    padding: 45px 24px 0;
}
.module_editor__img {
    padding: 16px 20px;
    border: 1px solid #E5E5E5;
    border-radius: 3px;
    max-height: 400px;
    max-width: 100%;
    vertical-align: top;
}
.module_editor__select_video,
.module_editor__select_img {
    position: relative;
}
.module_editor__select_video input,
.module_editor__select_img input {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    opacity: 0;
    z-index: 1;
    cursor: pointer;
}
.module_editor__video_view {
    width: 200px;
    margin-top: 10px;
}
.module_editor__text_input {
    .el-input-group__append {
        padding: 0 10px;
        .el-color-picker {
            height: auto;
        }
        .el-color-picker__trigger {
            height: 30px;
            width: 30px;
            padding: 0;
        }
    }
}
.module_editor__textarea {
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    .module_editor__textarea_input {
        .el-textarea__inner {
            border: none;
            resize: none;
        }
    }
    .module_editor__color {
        font-size: 12px;
        display: flex;
        height: 29px;
        padding: 5px;
        align-items: center;
        justify-content: flex-end;
        .el-color-picker {
            height: auto;
            margin-left: 5px; 
        }
        .el-color-picker__trigger {
            height: 19px;
            width: 19px;
            padding: 0;
        }
    }
}
.module_editor__form {
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
    }
    input[type="number"] {
        -moz-appearance: textfield;
    }
    .domTips{
        padding: 8px 10px;
        border-radius: 6px;
        font-size: 12px;
        color: #313131;
        margin-bottom: 20px;
        background-color: #FFF9D7;
    }
    .moudleType{
        display: flex;
        &>div{
            margin-right: 12px;
            cursor: pointer;
            .moudel{
                width: 81.5px;
                height: 86.5px;
                border-radius: 9px;
                position: relative;
                border: 0.5px solid #D0D0D0;
                .title{
                    width: 100%;
                    text-align: center;
                    font-size: 13px;
                    line-height: 13px;
                    position: absolute;
                    left: 0;
                    top: 7px;
                }
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            .text{
                text-align: center;
                font-size: 12px;
                color: #333333;
                margin-top: 7px;
                line-height: 12px;
            }
            &.selected{
                .text{
                    color: #2581FF;
                }
                .moudel{
                    &::before{
                        width: 81.5px;
                        height: 86.5px;
                        background: #00000080;
                        border-radius: 9px;
                        position: absolute;
                        left: 0;
                        top: 0;
                        content: '';
                    }
                }
            }
        }
    }
}
.scrollbar-default {
    &::-webkit-scrollbar-track-piece {
      background: #d3dce6;
    }
    &::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }
    &::-webkit-scrollbar-thumb {
      background: #99a9bf;
    }
}
.action_type_image {
}
.actionSelect_5 {
    width: 198px;
    height: 300px;
    background: url("./avatar/hongbao.png") 0 0 no-repeat;
    background-size: contain;
}
.actionSelect_6 {
    width: 198px;
    height: 300px;
    background: url("./avatar/lottery.png") 0 0 no-repeat;
    background-size: contain;
}
.actionSelect_8 {
    width: 198px;
    height: 300px;
    background: url("./avatar/price.png") 0 0 no-repeat;
    background-size: contain;
}
.actionSelect_9 {
    width: 198px;
    height: 300px;
    background: url("./avatar/custom.png") 0 0 no-repeat;
    background-size: contain;
}
.actionSelect_10 {
    width: 198px;
    height: 300px;
    background: url("./avatar/video_poster.png") 0 0 no-repeat;
    background-size: contain;
}
.actionSelect_11 {
    width: 198px;
    height: 300px;
    background: url("./avatar/privilege_bg.png") 0 0 no-repeat;
    background-size: contain;
}
.actionSelect_12 {
    width: 198px;
    height: 300px;
    background: url("./avatar/member_card_bg.png") 0 0 no-repeat;
    background-size: contain;
}
.actionSelect_13 {
    width: 198px;
    height: 300px;
    background: url("./avatar/package_bg.png") 0 0 no-repeat;
    background-size: contain;
}
.actionSelect_14 {
    width: 198px;
    height: 300px;
    background: url("./avatar/auto_charge_bg.png") 0 0 no-repeat;
    background-size: contain;
}
.actionSelect_23 {
  width: 198px;
  height: 300px;
  background: url("./avatar/brandDetail.png") 0 0 no-repeat;
  background-size: contain;
}
.actionSelect_20 {
  width: 198px;
  height: 300px;
  background: url("./avatar/pointsMall.png") 0 0 no-repeat;
  background-size: contain;
}
.actionSelect_21 {
  width: 198px;
  height: 300px;
  background: url("./avatar/pointsLottery.png") 0 0 no-repeat;
  background-size: contain;
}
.actionSelect_22 {
  width: 198px;
  height: 300px;
  background: url("./avatar/vote.png") 0 0 no-repeat;
  background-size: contain;
}
.actionSelect_24 {
  width: 198px;
  height: 300px;
  background: url("./avatar/myOrder.png") 0 0 no-repeat;
  background-size: contain;
}
.actionSelect_30 {
  width: 198px;
  height: 300px;
  background: url("./avatar/luckyMoneyFission.png") 0 0 no-repeat;
  background-size: contain;
}
</style>